import { render, staticRenderFns } from "./ReportCardSummary.vue?vue&type=template&id=4abd908a&scoped=true"
import script from "./ReportCardSummary.vue?vue&type=script&lang=ts"
export * from "./ReportCardSummary.vue?vue&type=script&lang=ts"
import style0 from "./ReportCardSummary.vue?vue&type=style&index=0&id=4abd908a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abd908a",
  null
  
)

export default component.exports